<!-- src/app/layout/shell/shell.component.html -->
<div id="w-root">
  <!-- TOP BAR -->
  <header id="w-topbar" role="banner">
    <div class="brand">
      <a routerLink="/accueil" [attr.aria-label]="'shell.brand.homeAriaLabel' | translate">
        <img src="assets/logo-horizontal.svg" alt="Waitora" />
      </a>
    </div>

    <div class="topbar-center" *ngIf="!isV2">
      <app-establishment-switcher
        [establishments]="session.establishments()"
        [selectedId]="session.selectedId()"
        (changed)="onEstablishmentChanged($event)">
      </app-establishment-switcher>
    </div>

    <div class="topbar-message" *ngIf="maintenanceBanner()">
      <app-maintenance-banner [message]="maintenanceBanner()" [compact]="true"></app-maintenance-banner>
    </div>

    <div class="actions">
      <button class="ora-wizard" *ngIf="showWizardCta()" (click)="openWizard()">
        <img class="ico" src="assets/IconORA.svg" alt="Ora" />
        <span>{{ wizardLabel() }}</span>
      </button>

      <!-- DEPRECATED (2026-09-08) : bouton "Action requise" retiré avec l'alerte qualité -- voir
           la note en tête de shell.component.ts.
      <button class="ora-wizard" *ngIf="showActionRequise()" (click)="toastService.showActionRequired()" [title]="'shell.actionRequired.title' | translate">
        <span style="line-height: 1;">⚠️</span>
        <span>{{ 'shell.actionRequired.label' | translate }}</span>
      </button>
      -->

      <!-- <button class="btn btn-supervision" *ngIf="router.url === '/pilotage'" (click)="openPilotageFullscreen()">
        <span class="btn-supervision-icon">⛶</span>
        <span>Mode supervision</span>
      </button> -->

      <div class="org-brand" *ngIf="isV2 && (orgLogoUrl() || orgName())">
        <img class="org-logo" *ngIf="orgLogoUrl()" [src]="orgLogoUrl()!" [alt]="orgName() || 'Logo du groupe'" />
        <span class="org-name" *ngIf="orgName()">{{ orgName() }}</span>
      </div>

      <div class="account-dropdown" (click)="$event.stopPropagation()">
        <button class="btn" (click)="toggleAccountMenu()">
          <span class="avatar-mini" *ngIf="isV2" [ngStyle]="currentUserAvatarStyle()" aria-hidden="true">{{ auth.currentUserInitials }}</span>
          <img class="ico" src="assets/compte.svg" alt="" aria-hidden="true" *ngIf="!isV2" />
          <span>{{ 'shell.account.button' | translate }}</span>
          <span class="dropdown-arrow">▼</span>
        </button>

        <div class="dropdown-menu" *ngIf="showAccountMenu()">
          <button class="dropdown-item" (click)="openAccount()">
            <svg class="dropdown-item-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            <span>{{ 'shell.account.myAccount' | translate }}</span>
          </button>
          <button class="dropdown-item" *ngIf="hasUserDroitPermission" (click)="openAddUser()">
            <svg class="dropdown-item-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>
            <span>{{ 'shell.account.addUser' | translate }}</span>
          </button>
          <button class="dropdown-item" *ngIf="hasUserDroitPermission" (click)="openUserList()">
            <svg class="dropdown-item-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            <span>{{ 'shell.account.userList' | translate }}</span>
          </button>
          <div class="dropdown-sep"></div>
          <div class="dropdown-item dropdown-lang" (click)="$event.stopPropagation()">
            <span class="dropdown-lang-label">{{ 'shell.account.language' | translate }}</span>
            <div class="lang-toggle" role="group" [attr.aria-label]="'shell.account.language' | translate">
              <button
                type="button"
                *ngFor="let lang of availableLanguages"
                class="lang-toggle-btn"
                [class.active]="lang.code === languageService.currentLang()"
                (click)="changeLang(lang.code)"
              >{{ lang.code | uppercase }}</button>
            </div>
          </div>
          <div class="dropdown-sep" *ngIf="isV2"></div>
          <button class="dropdown-item danger" *ngIf="isV2" (click)="logout()">
            <svg class="dropdown-item-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
            <span>{{ 'shell.account.logout' | translate }}</span>
          </button>
        </div>
      </div>

      <button class="btn outline" *ngIf="!isV2" (click)="logout()">
        <img class="ico" src="assets/deconexion.svg" alt="" aria-hidden="true" />
        <span>{{ 'shell.account.logout' | translate }}</span>
      </button>
    </div>
  </header>

  <!-- Mobile secondary topbar -->
  <div class="mobile-topbar" *ngIf="!isV2">
    <div class="mobile-establishment">
      <span class="mobile-label">{{ 'shell.mobileTopbar.establishmentLabel' | translate }}</span>
      <app-establishment-switcher
        [establishments]="session.establishments()"
        [selectedId]="session.selectedId()"
        (changed)="onEstablishmentChanged($event)">
      </app-establishment-switcher>
    </div>
  </div>

  <!-- LAYOUT -->
  <div id="w-main">
    <aside id="w-sidebar" role="navigation" [class.pinned]="sidebarPinned()">
      <nav>
        <button
          class="sidebar-pin-btn"
          type="button"
          (click)="toggleSidebarPin()"
          [title]="(sidebarPinned() ? 'shell.sidebar.unpin' : 'shell.sidebar.pin') | translate">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z"/>
          </svg>
        </button>

        <a *ngIf="hasPilotageMultiSitesPermission" routerLink="/pilotage" routerLinkActive="active" [title]="'shell.nav.supervision' | translate">
          <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" fill="currentColor"/>
          </svg>
          <span>{{ 'shell.nav.supervision' | translate }}</span>
        </a>
        <a *ngIf="hasSupervisionPermission" routerLink="/site" routerLinkActive="active" [title]="'shell.nav.sites' | translate">
          <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/>
          </svg>
          <span>{{ 'shell.nav.sites' | translate }}</span>
        </a>

        <a *ngIf="hasAccueilPermission && !hasSupervisionPermission" routerLink="/accueil" routerLinkActive="active" [title]="'shell.nav.realtime' | translate">
          <img class="icon" src="assets/attente.svg" alt="" aria-hidden="true" />
          <span class="menu-text-with-live">
            {{ 'shell.nav.realtime' | translate }}
            <span class="live-indicator">
              <span class="live-dot"></span>
              <span class="live-text">{{ 'shell.nav.live' | translate }}</span>
            </span>
          </span>
        </a>
        <a *ngIf="hasPrevisionsPermission && !hasSupervisionPermission" routerLink="/previsions" routerLinkActive="active" [title]="'shell.nav.planning' | translate">
          <img class="icon" src="assets/thermometre.svg" alt="" aria-hidden="true" />
          <span>{{ 'shell.nav.planning' | translate }}</span>
        </a>
        <a *ngIf="hasActualitePermission" routerLink="/actualite" routerLinkActive="active" class="menu-with-badge" [title]="'shell.nav.activityLog' | translate">
          <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6h16v2H4V6zm0 5h16v2H4v-2zm0 5h16v2H4v-2z" fill="currentColor"/>
          </svg>
          <span>{{ 'shell.nav.activityLog' | translate }}</span>
          <span *ngIf="unreadMentionsCount() > 0" class="badge-count">{{ unreadMentionsCount() }}</span>
        </a>
        <div class="nav-group" *ngIf="hasStatistiquesPermission" [class.open]="isPilotageSubmenuOpen">
          <button
            type="button"
            class="nav-group-row"
            (click)="toggleSubmenu($event)"
            [class.active]="isPilotageRowActive"
            [attr.aria-expanded]="isPilotageSubmenuOpen"
            [title]="'shell.nav.multiSitePiloting' | translate">
            <img class="icon" src="assets/pilotage.svg" alt="" aria-hidden="true" />
            <span>{{ 'shell.nav.multiSitePiloting' | translate }}</span>
            <svg class="nav-group-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <div class="nav-submenu-wrap" [class.open]="isPilotageSubmenuOpen">
            <div class="nav-submenu">
              <!-- Prévention en tête dès que le droit est actif (demande produit 2026-09-02) --
                   priorité de positionnement sur Avis patients/Communication patient, jamais l'inverse. -->
              <a *ngIf="hasPreventionPermission" routerLink="/pilotage-prevention" [class.active]="isPreventionNavActive" [title]="'shell.nav.prevention' | translate">
                <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.5 20.3c-.3.2-.7.2-1 0C7.6 17.8 3.4 14.2 3.4 9.9 3.4 7.1 5.5 5.2 8 5.2c1.4 0 2.7.7 3.6 1.8.9-1.1 2.2-1.8 3.6-1.8 2.5 0 4.6 1.9 4.6 4.7 0 4.3-4.2 7.9-8.3 10.4z"/>
                  <path d="M5.2 12.2h2.6l1.4-2.8 1.9 4.6 1.4-2.8h6.3"/>
                </svg>
                <span>{{ 'shell.nav.prevention' | translate }}</span>
              </a>
              <!-- Comm prévention (Lot "Comm prévention V1", 2026-09-08) : créer/diffuser/planifier
                   les campagnes -- distinct de Prévention > Campagne de prévention (mesurer/piloter). -->
              <a *ngIf="hasPreventionPermission" routerLink="/comm-prevention" routerLinkActive="active" [title]="'shell.nav.commPrevention' | translate">
                <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 11v2a2 2 0 0 0 2 2h1l3 5V4L6 9H5a2 2 0 0 0-2 2z"/>
                  <path d="M14 8.5c1 .8 1 4.2 0 5"/>
                  <path d="M17.5 6.5c2 2 2 7 0 9"/>
                </svg>
                <span>{{ 'shell.nav.commPrevention' | translate }}</span>
              </a>
              <a *ngIf="hasSatisfactionPermission" routerLink="/satisfaction" routerLinkActive="active" [title]="'shell.nav.patientReviews' | translate">
                <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
                </svg>
                <span>{{ 'shell.nav.patientReviews' | translate }}</span>
              </a>
              <a *ngIf="hasFilActualitePermission" routerLink="/fil-actualite" routerLinkActive="active" [title]="'shell.nav.patientComm' | translate">
                <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" fill="currentColor"/>
                </svg>
                <span>{{ 'shell.nav.patientComm' | translate }}</span>
              </a>
            </div>
          </div>
        </div>
        <a *ngIf="hasEtablissementPermission && !hasSupervisionPermission" routerLink="/etablissement" routerLinkActive="active" [title]="'shell.nav.settings' | translate">
          <img class="icon" src="assets/parametres.svg" alt="" aria-hidden="true" />
          <span>{{ 'shell.nav.settings' | translate }}</span>
        </a>

        <!-- DEPRECATED (2026-09-08) : entrée menu "Équipement" masquée à la demande produit --
             UNIQUEMENT l'UI d'administration des capteurs (EquipementsController côté backend) ;
             la pipeline de données waitora-capteur (Orange LoRaWAN, calcul d'occupation) continue
             de tourner et reste utilisée par supervision.component.ts pour le temps d'attente réel
             -- hors périmètre de cette dépréciation, ne pas y toucher sans décision produit séparée.
        <div class="supervision-separator" *ngIf="hasEquipementsPermission"></div>

        <a *ngIf="hasEquipementsPermission" routerLink="/equipements" routerLinkActive="active" class="supervision-link" [title]="'shell.nav.equipment' | translate">
          <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z" fill="currentColor"/>
          </svg>
          <span>{{ 'shell.nav.equipment' | translate }}</span>
        </a>
        -->

        <div class="danger-separator" *ngIf="hasApplicationMobilePermission"></div>

        <a *ngIf="hasApplicationMobilePermission" routerLink="/application-mobile" routerLinkActive="active" class="danger-link" [title]="'shell.nav.mobileApp' | translate">
          <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z" fill="currentColor"/>
          </svg>
          <span>{{ 'shell.nav.mobileApp' | translate }}</span>
        </a>

        <div class="nav-spacer"></div>

        <div *ngIf="hasKitCommunicationPermission && !hasSupervisionPermission" class="qr-code-section" (click)="openQrModal()">
          <span class="qr-label">{{ 'shell.nav.qrAccess' | translate }}</span>
          <img class="qr-code" src="/assets/3705521.png" [attr.alt]="'shell.nav.qrAltText' | translate" />
        </div>

        <div class="nav-separator"></div>

        <button type="button" (click)="openSupport()" [title]="'shell.nav.support' | translate">
          <img class="icon" src="assets/support.svg" alt="" aria-hidden="true" />
          <span>{{ 'shell.nav.support' | translate }}</span>
        </button>
      </nav>
    </aside>

    <section id="w-content" role="main">
      <div class="inner"><router-outlet></router-outlet></div>
    </section>
  </div>

  <!-- Navigation mobile bottom tab -->
  <nav class="mobile-nav" role="navigation">
    <a *ngIf="hasAccueilPermission && !hasSupervisionPermission" routerLink="/accueil" routerLinkActive="active" class="nav-item">
      <img src="assets/attente.svg" alt="" />
      <span class="menu-text-with-live">
        {{ 'shell.nav.realtime' | translate }}
        <span class="live-indicator">
          <span class="live-dot"></span>
        </span>
      </span>
    </a>
    <a *ngIf="hasActualitePermission" routerLink="/actualite" routerLinkActive="active" class="nav-item">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 6h16v2H4V6zm0 5h16v2H4v-2zm0 5h16v2H4v-2z" fill="currentColor"/>
      </svg>
      <span>{{ 'shell.nav.activityLogMobile' | translate }}</span>
      <span *ngIf="unreadMentionsCount() > 0" class="badge-count">{{ unreadMentionsCount() }}</span>
    </a>
  </nav>
</div>

<!-- Modale Compte -->
<app-account-modal *ngIf="showAccountModal()" (close)="closeAccount()"></app-account-modal>

<!-- Modale Ajouter utilisateur -->
<app-add-user-modal
  *ngIf="showAddUserModal()"
  (close)="closeAddUser()"
  (userAdded)="onUserAdded($event)">
</app-add-user-modal>

<!-- Modale Liste des utilisateurs -->
<app-user-list-modal
  *ngIf="showUserListModal()"
  (close)="closeUserList()">
</app-user-list-modal>

<!-- Modale Wizard (host dynamique) -->
<app-wizard-modal
  *ngIf="showWizardModal() && session.selectedId() as estId"
  [establishmentId]="estId"
  (close)="closeWizard()"
  (completed)="onWizardCompleted()">
</app-wizard-modal>

<!-- Modale Support -->
<app-support *ngIf="showSupportModal()" (close)="closeSupport()"></app-support>

<!-- Modale QR Code -->
<app-qr-modal 
  *ngIf="showQrModal()" 
  [establishmentId]="selectedEstablishmentId"
  (close)="closeQrModal()">
</app-qr-modal>

<!-- Toast notifications -->
<app-toast></app-toast>



